// extracted by mini-css-extract-plugin
export default {"breadcrumbWrapper":"xj1tn","crumbGroup":"_jH70","slash":"f3c5X","breadcrumbText":"a7bJ4","inverted":"zmHY2"};